<template>
  <div class="login" :style="{ height: winh + 'px' }">
    <div class="title">
      <!-- <div class="top-title">HELLO~代理人</div> -->
      <div class="bto-title">
        <p>登录区域代理人账号管理名下推广人{{flag}}</p>
        <p style="font-size:12px">说明：成为区域代理人需签订纸质代理协议书，经“工出头”平台授权后方可开通区域代理人账号。<br>开通账号请联系：13036028860 徐先生<br>其他问题请联系客服：400 600 1162</p>
      </div>
    </div>

    <div class="inputBox">
      <div class="content">
        <input
          type="text"
          class="myuser"
          placeholder="请输入您的账号"
          v-model="values.account"
        />
        <div class="aMypasw">
          <input
            type="password"
            class="mypasw"
            placeholder="请输入密码"
            v-model="values.password"
          />
          <span class="icon" @click="openFn"></span>
        </div>
      </div>
    </div>
    <div class="loginBt">
      <button
        @click="handleSubmit"
        :disabled="values.account.trim().length == 0 || values.password.trim().length == 0"
        :class="values.password.trim().length!=0 && values.account.trim().length!=0? 'active':''">登录
      </button>
      <van-cell is-link @click="showPopup" class="find">找回账号密码</van-cell>
      <van-popup v-model="show" :close-on-click-overlay='false'>
        <div class="pop">
          <div class="top">找回账户密码</div>
          <div class="num">
            <input
              type="text"
              placeholder="请输入您的手机号"
              v-model="phoneNum"
            />
          </div>
          <div class="btn">
            <div class="content">
              <span @click="delFn">取消</span>
              <span style="color: rgba(112, 178, 255, 1)" @click="sureFn">确定</span>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Vue from 'vue'
import agent from '@/agents/auth'
import { versionName } from '@/conf/env'
export default Vue.extend({
  components: {},
  data() {
    return {
      winh: 0,
      flag: versionName,
      values: {
        account: "",
        password: "",
      },
      phoneNum: "",
      show: false,
      myshow: false,
    };
  },
  created() {
    //背景图高度自适应
    let _this = this;
    this.winh = window.innerHeight;
    window.onresize = function () {
      _this.winh = window.innerHeight;
    };
    if (this.$vnode) {
     this.$vnode.parent.componentInstance.cache = {}
}
  },
  methods: {
    handleSubmit() {
      this.login()
    },
    async login() {
      const { ok, message, data } = await agent.login(this.values)
      if (!ok) {
        Toast({
          message: message,
          duration: 1000,
          overlay: false,
        });
      } else {
        localStorage.setItem('ttyh-agents',JSON.stringify(data))
        this.$router.push({ name: 'myUser'});
        this.values = {
          account: '',
          password: ''
        }
      }
    },
    openFn() {
      let myIcon = document.querySelector(".icon");
      let mypasw = document.querySelector(".mypasw");
      if (myIcon.className == "icon") {
        myIcon.className = "icon active";
        mypasw.type = "text";
      } else if (myIcon.className == "icon active") {
        myIcon.className = "icon";
        mypasw.type = "password";
      }
    },
    showPopup() {
      this.show = true;
    },
    sureFn() {
      this.show = false;
      if(this.phoneNum.replace(/\s*/g, '').length == 0) {
        this.show = true;
        Toast.fail('请填写手机号码');
        return
      }
      if(this.isPoneAvailable(this.phoneNum)) {
        this.getBackAccount()
      } else {
        Toast({
          message: '手机号码格式不对',
          duration: 1000,
          overlay: false,
        })
        this.show = true
      }
    },
    async getBackAccount() {
      const { ok, message, data } = await agent.get_back_account(this.phoneNum)
      if (!ok) {
        Toast({
          message: message,
          duration: 1000,
          overlay: false,
        });
      } else {
        Toast({
          message: message,
          duration: 1000,
          overlay: true,
        });
      }
      this.phoneNum = ''
    },
    delFn() {
      this.show = false;
      this.phoneNum = ''
    },
    isPoneAvailable(pone) {
         var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
         if (!myreg.test(pone)) {
         return false;
        } else {
          return true;
        }
     },
    
  },
});
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  background-image: url("../assets/bg.png");
  background-size: cover;
  overflow: hidden;
  background-repeat: no-repeat;
  .title {
    width: 90%;
    margin: 0 auto;
    margin-top: 85px;
    .top-title {
      font-weight: 700;
      font-size: 32px;
      color: #ffffff;
    }
    .bto-title {
      p {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        margin: 0px;
      }
      span {
        display: block;
        font-size: 12px;
        color: #ffffff;
        margin-top: 4px;
      }
    }
  }
  .inputBox {
    width: 100%;
    padding: 0px 31.97px;
    box-sizing: border-box;
    margin-top: 52px;
    .content {
      width: 100%;
      padding-bottom: 24px;
      border-bottom: 1px solid #b4d6ff;
      ::-webkit-input-placeholder {
        color: #bdbec1;
        font-size: 14px;
      }
      .myuser {
        display: block;
        width: 100%;
        height: 46px;
        border-radius: 24px;
        background-color: #ffffff;
        outline: none;
        border: none;
        margin-bottom: 16px;
        padding-left: 24px;
        box-sizing: border-box;
        font-size: 16px;
        color: #50525b;
      }
      .aMypasw {
        position: relative;
        .mypasw {
          display: block;
          width: 100%;
          height: 46px;
          border-radius: 24px;
          background-color: #ffffff;
          outline: none;
          border: none;
          padding-left: 24px;
          box-sizing: border-box;
          font-size: 16px;
          color: #50525b;
        }
        .icon {
          display: block;
          width: 24px;
          height: 24px;
          background-image: url("../assets/Eye-closed.png");
          background-size: 24px 24px;
          position: absolute;
          top: 50%;
          right: 24px;
          margin-top: -12px;
          &.active {
            background-image: url("../assets/Eye.png");
          }
        }
      }
    }
  }
  .loginBt {
    width: 100%;
    padding: 0px 31.97px;
    box-sizing: border-box;
    margin-top: 24px;
    button {
      display: block;
      width: 100%;
      // height: 46px;
      // line-height: 46px;
      padding: 10px 0px;
      box-sizing: border-box;
      text-align: center;
      border-radius: 67px;
      border: none;
      color: #888b94;
      background-color: #dcdde0;
      font-size: 16px;
      &.active {
        background: linear-gradient(180deg, #52d5ff 0%, #67b5fe 100%);
        box-shadow: 0px 0px 2px 2px rgba(248, 246, 246, 0.3);
        color: #ffffff;
      }
    }
    .find {
      display: block;
      width: 50%;
      font-size: 14px;
      margin: 0px;
      margin-top: 13px;
      padding: 0px;
      background-color: transparent;
    }
    .van-icon-arrow:before {
      display: none;
    }
    .van-cell__value--alone {
      color: #ffffff;
    }
    .van-cell::after {
      display: none;
    }
    .van-popup {
      width: 320px;
      height: 209px;
      border-radius: 8px;
    }
    .pop {
      width: 100%;
      overflow: hidden;
      .top {
        width: 100%;
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        margin-top: 32px;
      }
      .num {
        width: 100%;
        padding: 0px 24px;
        box-sizing: border-box;
        margin-top: 16px;
        input {
          width: 100%;
          height: 48px;
          border: none;
          background-color: rgba(243, 243, 243, 1);
          font-size: 16px;
          padding-left: 12px;
          box-sizing: border-box;
        }
      }
      .btn {
        width: 100%;
        padding: 0px 23.5px;
        box-sizing: border-box;
        margin-top: 49px;
        .content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          span {
            display: block;
            flex-grow: 1;
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }
  }
  .mypop {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
}
</style>
